/*
 * @Author: 孙照
 * @LastEditTime: 2023-04-23 14:05:20
 * @Description: 折线图通用 options 设置
 * @FilePath: \fuzhou\src\components\pubLineChart\defaultOption.js
 */
import { fitChartSize } from '@/utils/index';

export const basicOption = {
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    top: fitChartSize(30),
    left: 0,
    right: 0,
    bottom: 0,
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    boundaryGap: ['5%', '5%'],
    data: [],
    axisTick: {
      show: false, // x 轴刻度是否显示
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      color: '#A4A4A4',
      fontSize: fitChartSize(12),
      margin: fitChartSize(14),
    },
  },
  yAxis: [
    {
      name: 'kWh',
      nameLocation: 'end',
      nameTextStyle: {
        color: '#fff',
        align: 'right',
        fontSize: fitChartSize(12),
        padding: [0, fitChartSize(2), 0, 0],
      },
      type: 'value',
      axisLabel: {
        color: '#c5c5c5',
        fontSize: fitChartSize(12),
        margin: fitChartSize(6),
      },
      splitLine: {
        show: true,
        lineStyle: {
          width: 1,
          color: 'rgba(43, 196, 255, 0.5)',
          type: 'dashed',
        },
      },
    },
  ],
  series: [
    {
      name: 'kWh',
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        color: '#32BAFF',
        shadowColor: '#32BAFF',
        shadowBlur: 8,
      },
      lineStyle: {
        color: '#65FEE5',
      },
      data: [],
    },
  ],
};
